export const selectPOSMethodPaymentConfiguration = (
  state: IGlobalState,
): POSMethodPaymentConfiguration => state.pos.configuration
